module.exports = __webpack_public_path__ + "media/images/common/ico_03-0d56cbf14a4dcfe63afef81b29e0d5d4.png";